'use client'

import type { UserLawn } from '@/hooks/use-default-lawn'

const JUST_SCAN_VALUE = '__just_scan__'

interface AnalysisLawnChoiceProps {
  lawns: UserLawn[]
  choice: string | null | undefined
  onChange: (lawnId: string | null) => void
  mode?: 'identify' | 'diagnose' | 'weed'
}

export function AnalysisLawnChoice({
  lawns,
  choice,
  onChange,
  mode = 'identify',
}: AnalysisLawnChoiceProps) {
  if (lawns.length <= 1) return null

  const value = choice === null ? JUST_SCAN_VALUE : choice ?? ''
  const guidance = mode === 'identify'
    ? "We'll keep the result with the right lawn without creating another one."
    : "This keeps treatment guidance and follow-ups with the right lawn."

  return (
    <div className="mb-5 rounded-2xl border border-green-200 bg-green-50/70 p-4">
      <label htmlFor="analysis-lawn-choice" className="block text-sm font-semibold text-gray-900">
        Which lawn is this?
      </label>
      <p className="mt-1 text-xs leading-relaxed text-gray-600">
        {guidance}
      </p>
      <select
        id="analysis-lawn-choice"
        value={value}
        onChange={(event) => {
          onChange(event.target.value === JUST_SCAN_VALUE ? null : event.target.value)
        }}
        className="mt-3 h-11 w-full rounded-xl border border-green-200 bg-white px-3 text-sm font-medium text-gray-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/15"
      >
        <option value="" disabled>Choose a lawn</option>
        {lawns.map((lawn) => (
          <option key={lawn.id} value={lawn.id}>
            {lawn.name || 'Saved lawn'}
          </option>
        ))}
        <option value={JUST_SCAN_VALUE}>Just scan, don&apos;t attach it</option>
      </select>
    </div>
  )
}
